const mobile = 375;
const tablet = 765;
const wpDesktop = 783;
const laptop = 1025;
const wide = 1440;

module.exports = {
  tablet,
  laptop,
  wide,
  wpDesktop,
  customMedia: {
    '--mobile': `(min-width: ${mobile}px)`,
    '--tablet': `(min-width: ${tablet}px)`,
    '--wp-desktop': `(min-width: ${wpDesktop}px)`,
    '--laptop': `(min-width: ${laptop}px)`,
    '--wide': `(min-width: ${wide}px)`,
    '--tiny-height': `(max-height: 375px)`,
  },
};
